const colors = {
  dark: "#264652",
  dark_E: "#264652EE",
  dark_C: "#264652CC",
  dark_8: "#26465288",
  dark_4: "#26465244",
  mid: "#318887",
  light: "#499B8A",
  alt: "#E8B88C",
  accent: "#E06C4E",
  text: "#ffffff",
  //error: "#ff3333",
  error: "#E64D4D",
};
export default colors;
